import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { ButtonDesktop } from '@alfalab/core-components-button/esm/desktop';
import { Typography } from '@alfalab/core-components-typography/esm';
import { ArrowLeftMediumMIcon } from '@alfalab/icons-glyph/ArrowLeftMediumMIcon';
import { ArrowLeftMIcon } from '@alfalab/icons-glyph/ArrowLeftMIcon';

var styles = {"component":"navigation-bar-private__component_h6mvg","mobileComponent":"navigation-bar-private__mobileComponent_h6mvg","flex":"navigation-bar-private__flex_h6mvg","iconWrapper":"navigation-bar-private__iconWrapper_h6mvg","text":"navigation-bar-private__text_h6mvg","mobileWrapper":"navigation-bar-private__mobileWrapper_h6mvg"};
require('./index.css')

var BackArrowAddon = function (_a) {
    var _b, _c;
    var _d = _a.text, text = _d === void 0 ? 'Назад' : _d, onClick = _a.onClick, className = _a.className, _e = _a.textOpacity, textOpacity = _e === void 0 ? 1 : _e, view = _a.view, htmlAttributes = __rest(_a, ["text", "onClick", "className", "textOpacity", "view"]);
    var Icon = view === 'desktop' ? ArrowLeftMediumMIcon : ArrowLeftMIcon;
    var isMobileView = view === 'mobile';
    return (React.createElement(ButtonDesktop, __assign({ view: 'text', size: isMobileView ? 'xxs' : 's', onClick: onClick, "aria-label": '\u043D\u0430\u0437\u0430\u0434', className: cn(styles.component, (_b = {}, _b[styles.mobileComponent] = isMobileView, _b), className) }, htmlAttributes),
        React.createElement("div", { className: styles.flex },
            React.createElement("div", { className: cn(styles.iconWrapper, (_c = {},
                    _c[styles.mobileWrapper] = isMobileView,
                    _c)) },
                React.createElement(Icon, null)),
            textOpacity > 0 && text && (React.createElement(Typography.Text, { className: styles.text, view: view === 'desktop' ? 'primary-large' : 'component', weight: 'medium', style: { opacity: textOpacity } }, text)))));
};

export { BackArrowAddon };
